<ng-template #itemContent>
    <div class="icon">
        <mat-icon>{{icon}}</mat-icon>
    </div>
    <div class="text">
        <div class="title">{{title}}</div>
        <div class="subtitle">{{subtitle}}</div>
    </div>
</ng-template>

<div class="feature-item layout-{{layout}}" *ngIf="layout == 'full'">
    <ng-container [ngTemplateOutlet]="itemContent"></ng-container>
</div>

<div class="feature-item layout-{{layout}}" *ngIf="layout == 'compact'" [matTooltip]="title" matTooltipPosition="above">
    <ng-container [ngTemplateOutlet]="itemContent"></ng-container>
</div>
